import localForage from 'localforage'

localForage.config({
  name: process.env.APP_NAME,
})
